import React from 'react';
import { ShieldCheckIcon, CheckCircleIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="w-full bg-transparent py-8" data-id="element-52" data-mp="1o4ew0bauoq68">
      <div className="max-w-4xl mx-auto px-4 md:px-6" data-id="element-53" data-mp="1o5zsw7kn0l79">
        <div className="bg-gradient-to-b from-[#1A1A1A] to-[#141414] p-8 md:p-10 rounded-2xl border border-[#2A2A2A] relative overflow-hidden" data-id="element-54" data-mp="222db5iwzwqms">
          {/* Subtle top accent line */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-24 h-[2px] bg-[#C084FC]/60 rounded-full" data-id="element-55" data-mp="19dzd535wpub8" />

          <div className="flex flex-col items-center text-center" data-id="element-56" data-mp="14gpgp3k3oidw">
            {/* Icon */}
            <div className="w-16 h-16 rounded-full bg-[#C084FC]/10 border border-[#C084FC]/20 flex items-center justify-center mb-5" data-id="element-57" data-mp="1j5lulh8u8pmf">
              <ShieldCheckIcon className="w-8 h-8 text-[#9333EA]" data-id="element-58" data-mp="1ecivyup7epzd" />
            </div>

            {/* Title */}
            <p className="text-[10px] uppercase tracking-[0.2em] text-[#9333EA] font-bold mb-2" data-id="element-59" data-mp="qlwr1cahxltl">
              Compra protegida
            </p>
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 font-['Open_Sans',_sans-serif]" data-id="element-60" data-mp="p0b7vx1bzcgh">
              Garantía de satisfacción de 7 días
            </h2>

            {/* Divider */}
            <div className="w-12 h-[1px] bg-[#2A2A2A] mb-6" data-id="element-61" data-mp="yp2ya0qqtopa" />

            {/* Description */}
            <p className="text-gray-300 leading-relaxed max-w-xl mb-6 text-sm md:text-base" data-id="element-62" data-mp="12r6awsp5ezc5">
              Descargá el MegaPack, revisalo, usalo en tu sala. Si en los
              próximos 7 días sentís que no es lo que esperabas, escribinos y te
              devolvemos el 100% de tu dinero.
            </p>

            {/* Trust points */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-6" data-id="element-63" data-mp="f3gbpksj5o5d">
              {['Sin preguntas', 'Sin vueltas', 'Sin letra chica'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-64" data-mp="1qileeosnvmoz" data-mpi={i}>
                    <CheckCircleIcon className="w-4 h-4 text-[#9333EA]" data-id="element-65" data-mp="1veahh23w3lq1" />
                    <span className="text-sm text-gray-300" data-id="element-66" data-mp="3rhys01sdywfo">{item}</span>
                  </div>)}
            </div>

            {/* Closing statement */}
            <div className="bg-[#0A0A0A] border border-[#2A2A2A] rounded-lg px-6 py-3" data-id="element-67" data-mp="5b9x5v4sebnn">
              <p className="text-sm font-semibold text-[#9333EA]" data-id="element-68" data-mp="cfgozuakz6p">
                El riesgo es nuestro, no tuyo.
              </p>
            </div>
          </div>
        </div>

        <p className="text-xs text-gray-500 text-center mt-4 leading-relaxed" data-id="element-69" data-mp="38q606ap1zh9j">
          La confianza que tenemos en el MegaPack Psicopedagogía nos permite
          hacer esa promesa sin dudar. Más de 300 profesionales de todo el país
          ya lo saben. La tasa de devoluciones es menor al 1%.
        </p>
      </div>
    </section>;
}